import React from 'react';
import { SaleDetailItem, SaleDetails, SaleHeaderContent, SaleHeaderWrapper, SaleImage, SaleInfo, SaleSocial, SaleSocialItem, SaleTitle } from './styled';
import heartBeatsGIF from '../../../../assets/images/heartBeatsGIF.gif'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faTelegram, faDiscord } from "@fortawesome/free-brands-svg-icons";
import { faGlobe, faIdCard } from "@fortawesome/free-solid-svg-icons";
import useSale from '../../../../../hooks/useSale';
import { ISaleItem } from '../../../data/SaleList';
import { useActiveWeb3React } from '../../../../../hooks';


interface ISalePageProps {
    saleData: ISaleItem;
}

const SalePageHeader = (props: ISalePageProps) => {
    const { mintPriceText, setMintAmount, totalMinted, calculatingPrice } = useSale(props.saleData.name);
    const { chainId } = useActiveWeb3React();

    return (
        <SaleHeaderWrapper>
            <SaleHeaderContent>
                <SaleImage>
                    <img src={props.saleData.imgUrl} alt={props.saleData.title} height={150} width={150} />
                </SaleImage>
                <SaleInfo>
                    <SaleTitle>{props.saleData.title}</SaleTitle>
                    <SaleDetails>
                        <span>{props.saleData.subTitle}</span>
                        <SaleDetailItem>
                            <div>Mint Price:</div>
                            <span>{mintPriceText} AVAX</span>
                        </SaleDetailItem>
                        <SaleDetailItem>
                            <div>Public Sale Date:</div>
                            <span>{new Date(props.saleData.saleDate).toLocaleString()}</span>
                        </SaleDetailItem>
                        <SaleDetailItem>
                            <div>Total Minted:</div>
                            <span>{totalMinted}/{props.saleData.totalSupply}</span>
                        </SaleDetailItem>
                    </SaleDetails>
                </SaleInfo>
                <SaleSocial>
                    {props.saleData.twitter &&
                        <SaleSocialItem href={props.saleData.twitter} title={props.saleData.twitter} target="_blank">
                            <FontAwesomeIcon icon={faTwitter} />
                        </SaleSocialItem>
                    }
                    {props.saleData.telegram &&
                        <SaleSocialItem href={props.saleData.telegram} title={props.saleData.telegram} target="_blank">
                            <FontAwesomeIcon icon={faTelegram} />
                        </SaleSocialItem>
                    }
                    {props.saleData.discord &&
                        <SaleSocialItem href={props.saleData.discord} title={props.saleData.discord} target="_blank">
                            <FontAwesomeIcon icon={faDiscord} />
                        </SaleSocialItem>
                    }
                    {props.saleData.website &&
                        <SaleSocialItem href={props.saleData.website} title={props.saleData.website} target="_blank">
                            <FontAwesomeIcon icon={faGlobe} />
                        </SaleSocialItem>
                    }
                    {chainId &&
                        <SaleSocialItem href={"/collection/" + props.saleData.Addresses[chainId]} target="_blank">
                            <FontAwesomeIcon icon={faIdCard} />
                        </SaleSocialItem>
                    }
                </SaleSocial>
            </SaleHeaderContent>
        </SaleHeaderWrapper>
    )
}
export default SalePageHeader;